// @flow

import Resource from 'speed-js-core/src/api/Resource';

export default class NotificationScopeResource extends Resource {
    basePath: string = 'notifications/notification-scopes/';

    objectPath: string = 'notifications/notification-scopes/{ident}/';
}
